var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMic = function SvgMic(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_612:14927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1107 0C8.16071 0 6.57422 1.58649 6.57422 3.53648V10.4869C6.57422 12.4367 8.16071 14.0232 10.1107 14.0232C12.0607 14.0232 13.6472 12.4477 13.6472 10.5112V3.53648C13.6472 1.58649 12.0607 0 10.1107 0ZM12.1734 10.511C12.1734 11.6349 11.248 12.5494 10.1107 12.5494C8.97338 12.5494 8.04775 11.6243 8.04775 10.4867V3.53648C8.04775 2.39892 8.97314 1.47353 10.1107 1.47353C11.2483 1.47353 12.1736 2.39892 12.1734 3.53648V10.511Z",
    fill: "#3560FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8212 16.1328H9.34766V19.4483H10.8212V16.1328Z",
    fill: "#3560FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0234 18.7148H8.14302C7.73607 18.7148 7.40625 19.0447 7.40625 19.4516C7.40625 19.8586 7.73607 20.1884 8.14302 20.1884H12.0234C12.4303 20.1884 12.7601 19.8586 12.7601 19.4516C12.7601 19.0447 12.4303 18.7148 12.0234 18.7148Z",
    fill: "#3560FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6717 9.26562C15.2648 9.26562 14.935 9.59545 14.935 10.0024V10.5918C14.935 13.2594 12.7645 15.4299 10.0968 15.4299C7.429 15.4299 5.25869 13.2594 5.25869 10.5918V10.0024C5.25869 9.59545 4.92887 9.26562 4.52192 9.26562C4.11498 9.26562 3.78516 9.59545 3.78516 10.0024V10.5918C3.78516 14.0721 6.61657 16.9035 10.0968 16.9035C13.5771 16.9035 16.4085 14.0721 16.4085 10.5918V10.0024C16.4085 9.59549 16.0787 9.26562 15.6717 9.26562Z",
    fill: "#3560FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_612:14927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.1875,
    height: 20.1875,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMic);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mic.ad9965d2a67706f12639bc52d6632005.svg";